import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { GenericConfirmationComponent } from '../../home/components/generic-confirmation/generic-confirmation.component';
import { Injectable } from '@angular/core';

import { AuthService } from '../../../../core/services/auth.service';
import { environment } from '../../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { ModalService } from '../../../../core/services/modal.service';
import { ConfirmationDialogService } from '../../../../core/services/confirmation-dialog.service';

@Injectable()
export class OrderAcceptDeclineService {
  private acceptanceConfirmationModalRef: NgbModalRef;

  constructor(
    private modalService: ModalService,
    private httpClient: HttpClient,
    private authService: AuthService,
    private router: Router,
    private confirmationService: ConfirmationDialogService
  ) {}

  validate(guid: string): Observable<any> {
    const headers = this.authService.getBearerRequestHeaders();
    return this.httpClient.get(
      `${environment.orderConfirmationServiceUrl}/${guid}/validate`,
      { headers }
    );
  }

  confirmOrder(guid: string): Observable<any> {
    const headers = this.authService.getBearerRequestHeaders();
    return this.httpClient.get(
      `${environment.orderConfirmationServiceUrl}/${guid}/accept`,
      { headers }
    );
  }

  denyOrder(guid: string): Observable<any> {
    const headers = this.authService.getBearerRequestHeaders();
    return this.httpClient.get(
      `${environment.orderConfirmationServiceUrl}/${guid}/reject`,
      { headers }
    );
  }

  redirectAfterProcessing(result: {}) {
    this.router.navigate([`/secure/summary/${JSON.stringify(result)}`]);
  }

  showconfirmAcceptOrder(orderId: number): NgbModalRef {
    this.acceptanceConfirmationModalRef = this.modalService.open(
      GenericConfirmationComponent,
      { size: 'lg', container: '#AppContent' }
    );
    this.confirmationService.setup(this.acceptanceConfirmationModalRef, {
      bodyKey: 'ORDER-LIST.WARNING-ACCEPT-ORDER-QUESTION',
      cancelButtonKey: 'SHARED.WARNING-CLOSE-CANCEL',
      okButtonKey: 'SHARED.WARNING-ACCEPT-YES',
      titleKey: 'ORDER-LIST.WARNING-ACCEPT-ORDER-TITLE',
      confirmAction: undefined,
      contextValue: orderId
    });

    return this.acceptanceConfirmationModalRef;
  }

  showconfirmAcceptDossierOrder(orderIds: number[]): NgbModalRef {
    this.acceptanceConfirmationModalRef = this.modalService.open(
      GenericConfirmationComponent,
      { size: 'lg', container: '#AppContent' }
    );

    this.confirmationService.setup(this.acceptanceConfirmationModalRef, {
      bodyKey: 'ORDER-LIST.WARNING-ACCEPT-ORDER-DOSSIER-QUESTION',
      cancelButtonKey: 'SHARED.WARNING-CLOSE-CANCEL',
      okButtonKey: 'SHARED.WARNING-ACCEPT-YES',
      titleKey: 'ORDER-LIST.WARNING-ACCEPT-ORDER-DOSSIER-TITLE',
      confirmAction: undefined,
      contextValue: orderIds.map(id => id.toString())
    });

    return this.acceptanceConfirmationModalRef;
  }

  showconfirmRejectOrder(orderId: number): NgbModalRef {
    this.acceptanceConfirmationModalRef = this.modalService.open(
      GenericConfirmationComponent,
      { size: 'lg', container: '#AppContent' }
    );

    this.confirmationService.setup(this.acceptanceConfirmationModalRef, {
      bodyKey: 'ORDER-LIST.WARNING-REJECT-ORDER-QUESTION',
      cancelButtonKey: 'SHARED.WARNING-CLOSE-CANCEL',
      okButtonKey: 'SHARED.WARNING-DECLINE-YES',
      titleKey: 'ORDER-LIST.WARNING-REJECT-ORDER-TITLE',
      confirmAction: undefined,
      contextValue: orderId
    });

    return this.acceptanceConfirmationModalRef;
  }

  showconfirmRejectDossierOrder(orderIds: number[]): NgbModalRef {
    this.acceptanceConfirmationModalRef = this.modalService.open(
      GenericConfirmationComponent,
      { size: 'lg', container: '#AppContent' }
    );

    this.confirmationService.setup(this.acceptanceConfirmationModalRef, {
      bodyKey: 'ORDER-LIST.WARNING-REJECT-ORDER-DOSSIER-QUESTION',
      cancelButtonKey: 'SHARED.WARNING-CLOSE-CANCEL',
      okButtonKey: 'SHARED.WARNING-DECLINE-YES',
      titleKey: 'ORDER-LIST.WARNING-REJECT-ORDER-DOSSIER-TITLE',
      confirmAction: undefined,
      contextValue: orderIds.map(id => id.toString())
    });

    return this.acceptanceConfirmationModalRef;
  }
}
